// This file was auto-generated by Fern from our API Definition.
export var EvaluatorRevisionDataOutput;
(function (EvaluatorRevisionDataOutput) {
    EvaluatorRevisionDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(EvaluatorRevisionDataOutput || (EvaluatorRevisionDataOutput = {}));
